import { useEffect } from "react";
import { addPxPostfix } from "../../Shared/addPxPostfix";

export const useAutosizeTextArea = (
    textAreaRef: HTMLTextAreaElement | undefined,
    value: string,
    maxHeight?: number,
    callback?: () => void,
    startingHeight?: number,
) => {
    useEffect(() => {
        if (textAreaRef) {
            const minHeight = startingHeight ?? 40;
            // We need to reset the height momentarily to get the correct scrollHeight for the textarea
            textAreaRef.style.height = `${minHeight}px`;

            let scrollHeight = textAreaRef.scrollHeight;

            if (scrollHeight < minHeight) {
                scrollHeight = minHeight;
            }

            if (maxHeight && scrollHeight > maxHeight) {
                scrollHeight = maxHeight;
            }
            // We then set the height directly, outside of the render loop
            // Trying to set this with state or a ref will product an incorrect value.
            textAreaRef.style.height = addPxPostfix(scrollHeight);
            callback && callback();
        }
    }, [callback, maxHeight, textAreaRef, value]);
};
